import { get, put } from "./base";

const DeliverySettingsServ = {
    get: () => get("/delivery-settings"),
    update: (payload) => put("/delivery-settings", payload),
};

export default DeliverySettingsServ;
